function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M50 62.5c6.904 0 12.5-5.596 12.5-12.5S56.904 37.5 50 37.5 37.5 43.096 37.5 50 43.096 62.5 50 62.5z",
  stroke: "currentColor",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M80.833 62.5a6.875 6.875 0 001.375 7.583l.25.25a8.334 8.334 0 01-2.704 13.6 8.333 8.333 0 01-9.087-1.808l-.25-.25a6.875 6.875 0 00-7.584-1.375 6.875 6.875 0 00-4.166 6.292v.708A8.333 8.333 0 0142 87.5v-.375a6.876 6.876 0 00-4.5-6.292 6.875 6.875 0 00-7.583 1.375l-.25.25a8.335 8.335 0 01-13.6-2.704 8.333 8.333 0 011.808-9.087l.25-.25a6.875 6.875 0 001.375-7.584 6.875 6.875 0 00-6.292-4.166H12.5A8.333 8.333 0 0112.5 42h.375a6.875 6.875 0 006.292-4.5 6.875 6.875 0 00-1.375-7.583l-.25-.25a8.335 8.335 0 012.704-13.6 8.333 8.333 0 019.087 1.808l.25.25a6.875 6.875 0 007.584 1.375h.333a6.875 6.875 0 004.167-6.292V12.5a8.333 8.333 0 1116.666 0v.375a6.876 6.876 0 004.167 6.292 6.875 6.875 0 007.583-1.375l.25-.25a8.334 8.334 0 0113.6 2.704 8.333 8.333 0 01-1.808 9.087l-.25.25a6.874 6.874 0 00-1.375 7.584v.333a6.875 6.875 0 006.292 4.167h.708a8.333 8.333 0 110 16.666h-.375a6.876 6.876 0 00-6.292 4.167v0z",
  stroke: "currentColor",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgSettings;